import React, { useEffect } from "react";
// import Home from "../Home";
import Home from "./Home";
import Inputs from "../../../Inputs";
import WorkspaceHandler from "./Workspace";
import Ripple from "../Ripple";
import config from "../../../../config";
import Loader from "../../../stylized/Loader";
import { Tabs } from "react-bootstrap";
import RippleLog from "../RippleLog";
import { setChatList } from "../../../../actions/CommunicatorActions";
import { openInstance } from "../../../../actions/DashboardActions";
import Archive from "../Archive";
import Directory from "../LeftPane/Directory/Directory";
import WebGridInterface from "../../WebGridInterface";
import FlowSettings from "./document-chain/settings";
import Trash_Bin from "../Trash_Bin";
import Settings from "../Settings";
import Tutorial from "../Tutorial";
import ControlTowerForm from "../ControlTowerForm";
import RFCTVTest from "../RFCTVTest";
import ControlTower from "../ControlTower";
import Integrations from "../Integrations";
import IntegrationContainer from "./Integration";
import WorkspaceContainer from "./WorkspaceContainer";
import Communicator from "./communicator";
import { DocChain } from "./document-chain";
import http from "../../../../bae-client/HTTP";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Dashboard from "./document-chain/dashboard/dashboard";
import AggrDashboard from "./document-chain/aggr-dashboard/aggrDashboard";
import "./WorkspaceContainer/style.css";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import AlertDialog from "../../../stylized/AlertDialog";
import { setActivePage } from "../../../../actions";
import Compare from "./document-chain/compare";
import CheckBoxes from "../../../checkBox/Checkboxes";
import None from "../../../helper/None";
import Workspaces from "./Workspace/Workspaces";
import { ButtonComponent } from "../../../button/button";
import searchIcon from "../../../Inputs/img/search.svg";
import ChipNew from "../../../chip/ChipNew";
import ModalNew from "../../../modalDesign/ModalNew";
import FlowStep from "./document-chain/docu-chain-list/FlowStep";
import {
    setActivePageAction,
    setActiveWorkspaceAction,
    setSpaceListAction,
} from "../../../../services/services/app";
import AlertLog from "./Alerts/AlertLog";

export default function ContentPane({
    boardList,
    activePage,
    userName,
    closeModal,
    documentMetaData,
    handleLogout,
    setUser,
}) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const [error, setError] = React.useState(null);
    const [value, setValue] = React.useState("1");
    const [showLoader, setShowLoader] = React.useState(false);
    const [showAlertDialog, setShowAlertDialog] = React.useState(false);
    const [alertDialogMessage, setAlertDialogMessage] = React.useState("");
    const [emailConfigurationCuboidId, setEmailConfigurationCuboidId] =
        React.useState("");
    const [
        dashboardReportRuleConfCuboidId,
        setDashboardReportRuleConfCuboidId,
    ] = React.useState("");
    const [copyRuleConfCuboidId, setCopyRuleConfCuboidId] = React.useState("");
    const [compareRuleConfCuboidId, setCompareRuleConfCuboidId] =
        React.useState("");
    const openInstanceReducer = useSelector((state) => state.InstanceData);
    const homeRedirection = useSelector((state) => state.homeRedirection);
    const workspaceList = useSelector((state) => state.workspaceList);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };
    const getTabs = () => {
        setShowLoader(true);
        if (config.showLeftPaneDocumentChain) {
            // setShowLoader(true);
            http.sendRestRequest("documentChain/ruleConfigurationTblIds")
                .then((response) => {
                    setEmailConfigurationCuboidId(
                        response["Exception Email Rule Configuration"]
                    );
                    setDashboardReportRuleConfCuboidId(
                        response["Dashboard Report Rule Configuration"]
                    );
                    setCopyRuleConfCuboidId(
                        response["Copy Rule Configuration"]
                    );
                    setCompareRuleConfCuboidId(
                        response["Compare Rule Configuration"]
                    );
                })

                .catch((error) => {
                    console.log(error.message);
                    setShowAlertDialog(true);
                    setAlertDialogMessage(error.error);
                    setShowLoader(false);
                });
        }
    };
    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        if (inputValue.length > 5) {
            setError(true);
        } else if (inputValue.length === 5) {
            setError(false);
        } else {
            setError(null);
        }
    };

    useEffect(() => {
        if (openInstanceReducer) {
            setValue("2");
        }
    }, [openInstanceReducer]);
    useEffect(() => {
        if (homeRedirection?.flag) setValue("2");
    }, [homeRedirection?.flag]);
    useEffect(() => {
        getTabs();
        const params = new URLSearchParams(window.document.location.search);
        if (params.get("genericId") && params.get("instanceId")) {
            const libData = {
                genericId: params.get("genericId"),
                instanceIds: [parseInt(params.get("instanceId"))],
            };
            dispatch(openInstance(libData));
        }
        setShowLoader(true);
        http.sendRestRequest(
            `userLicenseAgreement/listByStatus?agreementStatus=PENDING`
        )
            .then((response) => {
                setShowLoader(false);
            })
            .catch((error) => {
                console.log(error);
                setShowAlertDialog(true);
                setAlertDialogMessage(error.error);
                setShowLoader(false);
            });
    }, []);
    useEffect(() => {
        // let basePathName = "";
        let basePathName = window.runtimeConfig.instanceName
            ? "/" + window.runtimeConfig.instanceName
            : "";
        // if (process.env.NODE_ENV !== "development") {
        //     basePathName += "/" + http.restApp + "/UnityCentral";
        // }
        if (
            location &&
            (location.pathname === basePathName + "/flow/" ||
                location.pathname === basePathName + "/flow")
        )
            dispatch(setActivePage("DocuChain"));
        else if (
            location &&
            (location.pathname === basePathName + "/home/" ||
                location.pathname === basePathName + "/home")
        )
            dispatch(setActivePage("HOME"));
        else if (
            location &&
            (location.pathname === basePathName + "/chat/" ||
                location.pathname === basePathName + "/chat")
        ) {
            let url = "communicator/chatList";
            setShowLoader(true);
            http.sendRestRequest(url)
                .then((res) => {
                    res.sort((a, b) => {
                        return (
                            Date.parse(b.messageOn.split(".")[0]) -
                            Date.parse(a.messageOn.split(".")[0])
                        );
                    });

                    http.sendRestRequest(
                        `communicator/chatMessageList?chatMessageCuboidId=${res[0].chatCuboidId}`
                    )
                        .then((response) => {
                            setChatList(response);
                            dispatch(setActivePage("Chat"));
                            setShowLoader(false);
                        })
                        .catch((error) => {
                            setShowAlertDialog(true);
                            setAlertDialogMessage(error.error);
                            console.log(error);
                            setShowLoader(false);
                        });
                })
                .catch((err) => {
                    setShowAlertDialog(true);
                    setAlertDialogMessage(err.error);
                    console.log(err);
                    setShowLoader(false);
                });
        } else if (
            location &&
            (location.pathname === basePathName + "/ripple/" ||
                location.pathname === basePathName + "/ripple")
        )
            dispatch(setActivePage("Ripple"));
        else if (
            location &&
            (location.pathname === basePathName + "/apps/" ||
                location.pathname === basePathName + "/apps")
        )
            dispatch(setActivePage("Apps"));
        else if (
            location &&
            (location.pathname === basePathName + "/directory/" ||
                location.pathname === basePathName + "/directory")
        )
            dispatch(setActivePage("Directory"));
        else if (
            location &&
            (location.pathname === basePathName + "/alertlog/" ||
                location.pathname === basePathName + "/alertlog")
        )
            dispatch(setActivePage("AlertLog"));
        else if (
            location &&
            (location.pathname === basePathName + "/archive/" ||
                location.pathname === basePathName + "/archive")
        )
            dispatch(setActivePage("Archive"));
        else if (
            location &&
            (location.pathname === basePathName + "/settings/" ||
                location.pathname === basePathName + "/settings")
        )
            dispatch(setActivePage("Settings"));
        else if (
            location &&
            (location.pathname === basePathName + "/controltower/" ||
                location.pathname === basePathName + "/controltower")
        )
            dispatch(setActivePage("Control Tower"));
        else if (
            location &&
            (location.pathname === basePathName + "/ripplelog/" ||
                location.pathname === basePathName + "/ripplelog")
        )
            dispatch(setActivePage("Ripple Log"));
        else if (
            location &&
            (location.pathname === basePathName + "/trashbin/" ||
                location.pathname === basePathName + "/trashbin")
        )
            dispatch(setActivePage("Trash Bin"));
        else if (
            location &&
            (location.pathname === basePathName + "/workspace/" ||
                location.pathname === basePathName + "/workspace")
        ) {
            const workspaceId = localStorage.getItem("workspaceId");
            const isRedirection = localStorage.getItem("redirectionObject");
            let workspace = null;
            if (workspaceId) {
                workspace = workspaceList.find(
                    (ws) => ws.workspaceId === parseInt(workspaceId)
                );
            }
            if (!workspace || workspace === undefined) {
                const tempWorkspaces = [...workspaceList];
                tempWorkspaces.sort((a, b) => {
                    return new Date(b.updatedOn) - new Date(a.updatedOn);
                });
                workspace = tempWorkspaces[0];
            }
            if (workspace && !isRedirection) {
                setShowLoader(true);
                http.sendRestRequest(
                    `workspace/spaceList?workspaceId=${workspace.workspaceId}`
                )
                    .then((response) => {
                        dispatch(setActivePageAction);
                        dispatch(setActiveWorkspaceAction(workspace));
                        dispatch(setSpaceListAction(response));
                        dispatch(setActivePageAction("Workspace"));
                        setShowLoader(false);
                    })
                    .catch((err) => console.log(err));
            } else dispatch(setActivePage("Workspace"));
        } else if (location && location.pathname === basePathName + "/")
            dispatch(setActivePage("HOME"));
    }, [location]);

    if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "HOME"
    ) {
        return (
            <>
                {/* <FlowStep
                    stepType={"instance"}
                    stepData={{
                        stepName: "Step 1",
                        stepId: 123,
                        fromEntity: "Facebook",
                        toEntity: "Amazon",
                        expectedDuration: "04/15/2024 5:30 PM",
                        storageLocation: "Workspace 1/Space 01",
                        promiseType: "Commitment",
                        blockType: "Promise",
                        documentName: "invoice.pdf",
                        branchName: "Branch 01"
                    }}
                    isMergeModal={false}
                ></FlowStep> */}
                <Home
                    username={userName}
                    //  alertData={this.state.homeAlerts}
                ></Home>
                {/* <CheckBoxes defaultCheck={true} /> */}
                {/* <ChipNew
                    label="long username"
                    color= "error"
                    size="medium"
                    deleteHandler={()=>{}}
                /> */}
                {/* <ModalNew
                    open={open}
                    handleClose={handleClose}
                    handleOpen={handleOpen}
                    title={"Modal Title"}
                    buttonText1={"Confirm"}
                    buttonText2={"Cancel"}
                    content={
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
                    }
                    status="Normal" // Normal Danger
                    submitHandler={() => {}}
                /> */}
                {/* // <ButtonComponent
            //     type={"ghost"}
            //     icon={true}
            //     text={""}
            //     BtnHandler={() => {}}
            //     disable={false}
            // /> */}
                {/* /* <Inputs
                disable={false}
                id="test"
                type="text"
                placeholder="Enter Your Name"
                isError={error}
                // icon={searchIcon}
                onChange={handleInputChange}
            /> */}
            </>
        );
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Workspace"
    ) {
        //return <WorkspaceHandler username={userName}></WorkspaceHandler>;
        // return <WorkspaceContainer username={userName}></WorkspaceContainer>;
        return <Workspaces></Workspaces>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Ripple"
    ) {
        return <Ripple username={userName}></Ripple>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "AlertLog"
    ) {
        return <AlertLog></AlertLog>;
    }
    // else if (
    //     activePage !== undefined &&
    //     activePage !== "" &&
    //     activePage === "Directory"
    // ) {
    //     return <Directory username={userName}></Directory>;
    // }
    else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Directory"
    ) {
        return <Directory username={userName}></Directory>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Control Tower"
    ) {
        return <ControlTower username={userName}></ControlTower>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Ripple Log"
    ) {
        return <RippleLog username={userName}></RippleLog>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        (activePage === "Communicator" || activePage === "Chat")
    ) {
        return <Communicator></Communicator>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        (activePage === "Apps" || activePage === "Integrations")
    ) {
        return (
            // <Integrations></Integrations>
            <IntegrationContainer></IntegrationContainer>
        );
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Archive"
    ) {
        return <Archive username={userName}></Archive>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Trash Bin"
    ) {
        return <Trash_Bin username={userName}></Trash_Bin>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Settings"
    ) {
        return (
            <Settings
                username={userName}
                handleLogout={handleLogout}
                setUser={setUser}
            ></Settings>
        );
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Tutorial"
    ) {
        return <Tutorial username={userName}></Tutorial>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Form"
    ) {
        return <ControlTowerForm username={userName}></ControlTowerForm>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "Test API"
    ) {
        return <RFCTVTest></RFCTVTest>;
    } else if (
        activePage !== undefined &&
        activePage !== "" &&
        activePage === "DocuChain"
    ) {
        return (
            <>
                <Box
                    sx={{
                        width: "100%",
                        typography: "body1",
                        height: "90vh",
                        paddingTop: "35px",
                    }}
                >
                    <TabContext value={value}>
                        <Box
                            sx={{
                                borderBottom: 1,
                                borderColor: "divider",
                                marginLeft: "24px",
                            }}
                        >
                            <TabList
                                onChange={handleTabChange}
                                aria-label="lab API tabs example"
                            >
                                <Tab
                                    id="tab_dashboard_flow"
                                    data-id="tab_dashboard_flow"
                                    label="Dashboard"
                                    title="Dashboard"
                                    value="1"
                                    sx={{
                                        width: "111px",
                                        height: "52px",
                                        color: "#4B5362",
                                        marginRight: "30px !important",
                                        fontFamily: "Montserrat",
                                        fontSize: "18px",
                                        lineHeight: "29px",
                                        textTransform: "capitalize",
                                    }}
                                />
                                <Tab
                                    id="tab_library_flow"
                                    data-id="tab_library_flow"
                                    label="Library"
                                    title="Library"
                                    value="2"
                                    sx={{
                                        width: "111px",
                                        height: "52px",
                                        color: "#4B5362",
                                        marginRight: "30px !important",

                                        fontFamily: "Montserrat",
                                        fontSize: "18px",
                                        lineHeight: "29px",
                                        textTransform: "capitalize",
                                    }}
                                />
                                <Tab
                                    id="tab_report_flow"
                                    data-id="tab_report_flow"
                                    label="Report"
                                    title="Report"
                                    value="3"
                                    sx={{
                                        width: "111px",
                                        height: "52px",
                                        color: "#4B5362",
                                        marginRight: "30px !important",

                                        fontFamily: "Montserrat",
                                        fontSize: "18px",
                                        lineHeight: "29px",
                                        textTransform: "capitalize",
                                    }}
                                />
                                <Tab
                                    id="tab_compare_flow"
                                    data-id="tab_compare_flow"
                                    label="Compare"
                                    title="Compare"
                                    value="4"
                                    sx={{
                                        width: "111px",
                                        height: "52px",
                                        color: "#4B5362",
                                        marginRight: "30px !important",

                                        fontFamily: "Montserrat",
                                        fontSize: "18px",
                                        lineHeight: "29px",
                                        textTransform: "capitalize",
                                    }}
                                />
                                <Tab
                                    id="tab_settings_flow"
                                    data-id="tab_settings_flow"
                                    label="Settings"
                                    title="Settings"
                                    value="5"
                                    sx={{
                                        width: "111px",
                                        height: "52px",
                                        color: "#4B5362",
                                        marginRight: "30px !important",

                                        fontFamily: "Montserrat",
                                        fontSize: "18px",
                                        lineHeight: "29px",
                                        textTransform: "capitalize",
                                    }}
                                />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <Dashboard />
                        </TabPanel>
                        <TabPanel value="2" sx={{ padding: "0px" }}>
                            <DocChain></DocChain>
                        </TabPanel>
                        <TabPanel value="3" style={{ height: "92vh" }}>
                            <AggrDashboard></AggrDashboard>
                        </TabPanel>
                        <TabPanel
                            value="4"
                            style={{ height: "92vh", padding: "0px" }}
                        >
                            <Compare></Compare>
                        </TabPanel>
                        <TabPanel
                            value="5"
                            sx={{ padding: "0px", height: "calc(100% - 50px)" }}
                            style={{ height: "calc(100% - 50px)" }}
                        >
                            <FlowSettings
                                config={config}
                                emailConfigurationCuboidId={
                                    emailConfigurationCuboidId
                                }
                                dashboardReportRuleConfCuboidId={
                                    dashboardReportRuleConfCuboidId
                                }
                            ></FlowSettings>
                        </TabPanel>
                    </TabContext>
                </Box>
                <AlertDialog
                    open={showAlertDialog}
                    message={alertDialogMessage}
                    title={""}
                    isAlert={false}
                ></AlertDialog>
                <Loader show={showLoader} />
            </>
        );
    } else {
        return <None></None>;
    }
    // } else if (activePage === "HOME") {
    //     return (
    //         <Home
    //             username={userName}
    //         //  alertData={this.state.homeAlerts}
    //         ></Home>
    //     );
    // }

    // else return null;
}
